// extracted by mini-css-extract-plugin
export default {"button":"XcomButton_button__qqM03","consent-given":"XcomButton_consent-given__7NYsM","consent-refused":"XcomButton_consent-refused__D5-9I"};